import {
  Backdrop,
  Box,
  CircularProgress,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useMemo } from "react";
import Header from "./Header";
import Footer from "./Footer";
import ErrorSuccessSnackbar from "./ErrorSuccessSnackbar";
import CompareBar from "./CompareBar";
import FavoritesBar, {
  COMPARE_BAR_HEIGHT_DESKTOP,
  COMPARE_BAR_HEIGHT_MOBILE,
} from "./FavoritesBar";
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "../store/uiSlice";
import useFavorites from "../hooks/useFavorites";
import useCompare from "../hooks/useCompare";
// import { useRouter } from "next/router";
import {
  Outlet,
  ScrollRestoration,
  useLocation,
} from "react-router-dom";
import { getAllAnnonces } from "../requests/annonces";
import { setAllAnnonces } from "../store/annonceSlice";
import { getCurrent } from "../util/getCurrent";
import { disconnect, setConnected } from "../store/authSlice";
import { usePageTracking } from "../hooks/usePageTracking";

type Props = {};

const Loader = () => {
  const { isLoading, message } = useSelector(selectLoading);
  return (
    <Backdrop
      open={!!isLoading}
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Paper sx={{ p: 2 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography>{message}</Typography>
          <CircularProgress />
        </Box>
      </Paper>
    </Backdrop>
  );
};

const Layout = (_props: Props) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const { favoritesCount } = useFavorites();
  const { compareCount } = useCompare();

  // Calcule le padding dynamique basé sur les barres visibles
  const bottomPadding = useMemo(() => {
    const compareHeight = compareCount > 0
      ? (isMobile ? COMPARE_BAR_HEIGHT_MOBILE : COMPARE_BAR_HEIGHT_DESKTOP)
      : 0;
    const favoritesHeight = favoritesCount > 0
      ? (isMobile ? 100 : 150) // Hauteur approximative de FavoritesBar
      : 0;
    // Ajoute un padding de base de 20px
    return compareHeight + favoritesHeight + 20;
  }, [compareCount, favoritesCount, isMobile]);
  
  // Initialize Google Ads page tracking
  usePageTracking();
  useEffect(() => {
    if (localStorage.getItem("token") !== null) {
      getCurrent(localStorage.getItem("token") as string).then((res) => {
        console.log(res);
        if (res !== "error") {
          dispatch(
            setConnected({
              data: res,
              token: localStorage.getItem("token") as string,
            })
          );
        } else {
          dispatch(disconnect());
        }
      });
    } else {
      dispatch(disconnect());
    }
  }, [location.pathname]);
  useEffect(() => {
    if (!location.pathname.includes("/tableau-de-bord")) {
      getAllAnnonces().then((res) => {
        if (res !== "error") {
          dispatch(setAllAnnonces(res));
        }
      });
    }
  }, [location.pathname]);

  if (location.pathname.includes("/modification")) {
    return (
      <main>
        <Outlet />
        <ErrorSuccessSnackbar />
        <Loader />
        <ScrollRestoration />
      </main>
    );
  }

  return (
    <>
      {/* Skip link pour l'accessibilité clavier */}
      <a href="#main-content" className="skip-link">
        Aller au contenu principal
      </a>
      <Header />
      <main
        id="main-content"
        style={{
          backgroundColor: "white",
          paddingBottom: bottomPadding,
          transition: "padding-bottom 0.3s ease-in-out",
        }}
        role="main"
      >
        <Outlet />
      </main>
      <CompareBar />
      <FavoritesBar />
      <Footer />
      <ErrorSuccessSnackbar />
      <Loader />
      <ScrollRestoration />
    </>
  );
};

export default Layout;
